import { Controller } from "stimulus";
import notify from "../packs/notify";
import i18next from "i18next";

const rules = {
  "owner[email]": { required: false, email: true },
  "owner[phone1]": { required: false, phone: true },
};

export default class extends Controller {
  static targets = [""];
  static values = {};

  connect() {}

  validate(e) {
    const isRequired = rules[e.target.name]["required"];
    const isEmail = rules[e.target.name]["email"];
    const isPhone = rules[e.target.name]["phone"];
    const value = e.target.value;

    if (isEmail) this.emailRule(e, isEmail, isRequired, value);
    if (isPhone) this.phoneRule(e, isPhone, isRequired, value);

    // TO-DO we can continue and expand for other rules for the next release
    // if (isRequired && !value) {
    //   console.log("Problemmmm");
    // }
  }

  emailRule(e, isEmail, isRequired, value) {
    if (!isRequired && !value) {
      this.hideError(e);
      return;
    }

    if (isEmail) {
      if (!this.emailValidation(value)) {
        const msg = i18next.t("Please enter a valid email address");
        this.showError(e, msg);
      } else {
        this.hideError(e);
      }
    }
  }

  phoneRule(e, isPhone, isRequired, value) {
    if (!isRequired && !value) {
      this.hideError(e);
      return;
    }

    if (isPhone) {
      if (!this.phoneValidation(value)) {
        const msg = i18next.t("Please enter a valid phone number");
        this.showError(e, msg);
      } else {
        this.hideError(e);
      }
    }
  }

  emailValidation(email) {
    return email.match(/^\S+@\S+\.\S+$/);
  }

  phoneValidation(phone) {
    const reg = /^((\+1)|1)? ?\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})( ?(ext\.? ?|x)(\d*))?$/;
    return phone.match(reg);
  }

  hideError(e) {
    const element = e.target;
    if (element) {
      element.classList.remove("required-field");
      element.setAttribute("data-valid", true);
    }
    const errorField = e.target.nextElementSibling;
    if (errorField) errorField.hidden = true;
  }

  showError(e, msg) {
    const element = e.target;
    if (element) {
      element.setAttribute("data-valid", false);
      element.classList.add("required-field");
    }
    const errorField = e.target.nextElementSibling;
    if (errorField) {
      errorField.hidden = false;
      errorField.innerText = msg;
    } else {
      notify({
        message: msg,
        status: "error",
      });
    }
  }
}
